import React from 'react'

const DevOps = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={59}
      height={59}
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#7b68ee"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M46.277 27.662H12.533V9.868a2.31 2.31 0 0 1 2.301-2.32h29.142c1.27 0 2.3 1.038 2.3 2.32zm0 3.094a2.31 2.31 0 0 1-2.301 2.321H14.834a2.31 2.31 0 0 1-2.3-2.32v-1.548h33.743zm-20.46 7.737l1.093-3.868h4.97l1.093 3.868zM43.967 6H14.833c-2.116.003-3.83 1.733-3.833 3.868v20.888c.002 2.136 1.717 3.866 3.833 3.869h10.484l-1.095 3.868h-2.489v1.547h15.334v-1.547h-2.489l-1.095-3.868h10.484c2.116-.003 3.83-1.733 3.833-3.869V9.868C47.798 7.733 46.083 6.003 43.967 6z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M35.237 50.413H15.293v-7.876h19.944zm.756-9.453H14.527a.778.778 0 0 0-.767.789v9.462c0 .436.343.789.767.789h21.466a.778.778 0 0 0 .767-.789V41.75a.778.778 0 0 0-.767-.789z"
            />
          </g>
          <g>
            <path fill="#fff" d="M17.44 47.4h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M17.44 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M20.2 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M22.96 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M29.4 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M25.72 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M32.16 47.4h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M32.16 44.64h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M20.2 47.4h10.12v.92H20.2z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M43.374 48.05c0 1.305-1.11 2.363-2.479 2.363-1.37 0-2.479-1.058-2.479-2.363V44.9c0-1.305 1.11-2.363 2.479-2.363 1.37 0 2.479 1.058 2.479 2.363zM40.9 40.96c-2.286 0-4.14 1.765-4.14 3.943v3.154c0 2.178 1.854 3.943 4.14 3.943 2.286 0 4.14-1.765 4.14-3.943v-3.154c0-2.178-1.854-3.943-4.14-3.943z"
            />
          </g>
          <g>
            <path fill="#fff" d="M40.44 44.64h.92v.92h-.92z" />
          </g>
          <g transform="rotate(-74.032 29 18)">
            <path fill="#fff" d="M23.82 17.51h11.158v1.533H23.82z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M24.8 14.585l-.925-1.225-4.335 3.988a.856.856 0 0 0-.092 1.123.763.763 0 0 0 .092.101l4.335 3.988.925-1.225-3.67-3.375z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M39.352 17.45a.763.763 0 0 0-.092-.102l-4.335-3.988L34 14.585l3.67 3.375L34 21.335l.925 1.225 4.335-3.988a.856.856 0 0 0 .092-1.123z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default DevOps
